// extracted by mini-css-extract-plugin
module.exports = {"figure":"style-module--figure--3oKXz","cutted":"style-module--cutted--2ky9N"};